import { useContext } from 'react'
import { AuthContext } from './AuthProvider'

export interface AuthUser {
  sub: string
  email: string
  name: string
  groups: string[]
}

export interface AuthState {
  isAuthenticated: boolean
  user: AuthUser | null
  token: string | null
  isLoading: boolean
  login: () => void
  logout: () => void
  handleCallback: () => Promise<void>
}

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return ctx
}
